export default "__VITE_ASSET__DTZOPs8I__"